var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MediaSizeInput',{attrs:{"raw-image":_vm.image},on:{"update-image":_vm.updateImage},model:{value:(_vm.syncedValue),callback:function ($$v) {_vm.syncedValue=$$v},expression:"syncedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }